export default __webpack_public_path__ + "68f60e951f7f191c5d7670942823e3a8.svg";